package com.dotdrives.web.pages.givers

import com.dotdrives.design.DotTone

data class TimelinePresentation(
    val icon: String,
    val title: String,
    val body: String?,
)

fun timelinePresentation(
    verb: String,
    payload: Map<String, String>,
): TimelinePresentation = when (verb) {
    "giver.created" -> TimelinePresentation(
        icon = "👤",
        title = "Giver created",
        body = payload["snippet"],
    )
    "note.added" -> TimelinePresentation(
        icon = "📝",
        title = payload["title"].orEmpty().ifBlank { "Note added" },
        body = payload["snippet"],
    )
    "giver.updated" -> TimelinePresentation(
        icon = "•",
        title = "Profile updated",
        body = payload["snippet"],
    )
    else -> TimelinePresentation(
        icon = "•",
        title = verb
            .substringAfterLast('.')
            .replace('_', ' ')
            .replaceFirstChar(Char::uppercase),
        body = payload["snippet"],
    )
}

data class TimelineTone(
    val tone: DotTone,
    val label: String,
)

fun timelineTone(verb: String): TimelineTone = when (verb) {
    "giver.created" -> TimelineTone(DotTone.Neutral, "Giver")
    "note.added" -> TimelineTone(DotTone.Automation, "Note")
    else -> TimelineTone(DotTone.Neutral, "Update")
}

fun paginationWindow(
    currentPage: Int,
    totalPages: Int,
): List<Int?> {
    if (totalPages <= 1) return listOf(1)
    if (totalPages <= 5) return (1..totalPages).toList()

    val pages = buildSet {
        add(1)
        add(totalPages)
        if (currentPage <= 3) {
            addAll(2..4)
        } else if (currentPage >= totalPages - 2) {
            addAll((totalPages - 3)..(totalPages - 1))
        } else {
            addAll((currentPage - 1)..(currentPage + 1))
        }
    }.sorted()

    return buildList {
        pages.forEachIndexed { index, page ->
            if (index > 0 && page - pages[index - 1] > 1) add(null)
            add(page)
        }
    }
}
